import React from "react";
import ChevronDownIconModule from "./ChevronDownIcon.module.css";

export interface ChevronDownIconProps {
  isBackEnabled: boolean;
}

export const ChevronDownIcon: React.FC<ChevronDownIconProps> = ({ isBackEnabled }: ChevronDownIconProps) => {
  return <span className={`${ChevronDownIconModule.Chevron} ${!isBackEnabled && ChevronDownIconModule.ChevronDisabled}`} />;
};
